

// import React, { useState, useEffect, useMemo } from "react";
// import axios from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";
// import "../../style/CreateUser.css";

// // const API_ROOT = "http://localhost:5001/api/users";
// // const API_USUARIOS = `${API_ROOT}/usuarios`;
// // const API_SEDES = `${API_ROOT}/sedes`;
// // const API_TENANT = `${API_ROOT}/tenant`;

// const API_ROOT = "http://3.236.217.225:5001/api/users";
// const API_USUARIOS = `${API_ROOT}/usuarios`;
// const API_SEDES = `${API_ROOT}/sedes`;
// const API_TENANT = `${API_ROOT}/tenant`;

// export default function CreateUser() {
//   const { token, logout, user } = useAuth();
//   const tenant_id = user?.tenant_id;

//   const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

//   const [formData, setFormData] = useState({
//     username: "",
//     password: "",
//     role: "estudiante",
//     nombre: "",
//     apellido: "",
//     documento: "",
//     email: "",
//     telefono: "",
//     fecha_nacimiento: "",
//     direccion: "",
//     asignar_a: "tenant",
//     sede_id: ""
//   });

//   const [usuarios, setUsuarios] = useState([]);
//   const [sedes, setSedes] = useState([]);
//   const [tenantNombre, setTenantNombre] = useState("");
//   const [editandoId, setEditandoId] = useState(null);
//   const [error, setError] = useState("");
//   const [msg, setMsg] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const usuariosPorPagina = 5;

//   useEffect(() => {
//     if (token && tenant_id) {
//       obtenerUsuarios();
//       obtenerSedes();
//       obtenerNombreTenant();
//     }
//   }, [token, tenant_id]);

//   const obtenerUsuarios = async () => {
//     try {
//       const res = await axios.get(API_USUARIOS, { headers });
//       setUsuarios(res.data || []);
//     } catch (err) {
//       console.error("❌ Error usuarios:", err);
//       if ([401, 403].includes(err.response?.status)) logout();
//       else setError("No se pudieron cargar los usuarios");
//     }
//   };

//   const obtenerSedes = async () => {
//     try {
//       const res = await axios.get(`${API_SEDES}?tenant_id=${tenant_id}`, { headers });
//       setSedes(res.data || []);
//     } catch (err) {
//       console.warn("⚠️ Error sedes:", err.message);
//       setSedes([]);
//     }
//   };

//   const obtenerNombreTenant = async () => {
//     try {
//       const res = await axios.get(`${API_TENANT}/${tenant_id}`, { headers });
//       setTenantNombre(res.data?.nombre || "");
//     } catch (err) {
//       console.warn("⚠️ Error tenant:", err.message);
//       setTenantNombre("");
//     }
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value, ...(name === "documento" && { username: value }) }));
//     setError(""); setMsg("");
//   };

//   const guardarUsuario = async () => {
//     if (!token) return setError("Sesión expirada");
//     if (!formData.documento) return setError("Documento obligatorio");
//     if (!formData.nombre || !formData.apellido) return setError("Nombre y apellido obligatorios");
//     if (!formData.role) return setError("Rol obligatorio");
//     if (!editandoId && (!formData.password || formData.password.length < 6))
//       return setError("Contraseña mínima 6 caracteres");

//     let sede_id = formData.asignar_a === "sede" ? Number(formData.sede_id) : null;

//     const dataToSend = { ...formData, username: formData.documento, tenant_id, sede_id };

//     try {
//       if (editandoId) {
//         const rectorUsername = prompt("Usuario del rector:");
//         const rectorPassword = prompt("Contraseña del rector:");
//         if (!rectorUsername || !rectorPassword) return setError("Credenciales del rector requeridas");

//         dataToSend.rectorUsername = rectorUsername;
//         dataToSend.rectorPassword = rectorPassword;

//         if (!dataToSend.password) delete dataToSend.password;

//         await axios.put(`${API_USUARIOS}/${editandoId}`, dataToSend, { headers });
//         setMsg("✅ Usuario actualizado");
//       } else {
//         await axios.post(API_USUARIOS, dataToSend, { headers });
//         setMsg("✅ Usuario creado");
//       }

//       limpiarFormulario();
//       obtenerUsuarios();
//     } catch (err) {
//       console.error("❌ Guardar usuario:", err.response?.data || err);
//       setError(err.response?.data?.message || "Error al guardar");
//     }
//   };

//   const limpiarFormulario = () => {
//     setFormData({
//       username: "", password: "", role: "estudiante", nombre: "", apellido: "",
//       documento: "", email: "", telefono: "", fecha_nacimiento: "", direccion: "",
//       asignar_a: "tenant", sede_id: ""
//     });
//     setEditandoId(null);
//     setError(""); setMsg("");
//   };

//   const eliminarUsuario = async (id) => {
//     const confirm = window.confirm("⚠️ ¿Seguro quieres eliminar este usuario?");
//     if (!confirm) return;

//     try {
//       const rectorUsername = prompt("Usuario del rector:");
//       const rectorPassword = prompt("Contraseña del rector:");
//       if (!rectorUsername || !rectorPassword) return setError("Credenciales del rector requeridas");

//       await axios.delete(`${API_USUARIOS}/${id}`, {
//         headers,
//         data: { rectorUsername, rectorPassword }
//       });
//       setMsg("✅ Usuario eliminado");
//       obtenerUsuarios();
//     } catch (err) {
//       console.error("❌ Eliminar usuario:", err.response?.data || err);
//       setError(err.response?.data?.message || "Error al eliminar usuario");
//     }
//   };

//   const filteredUsuarios = usuarios.filter(u =>
//     u.nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     u.apellido?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     u.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     u.documento?.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   const indexUltimo = currentPage * usuariosPorPagina;
//   const indexPrimero = indexUltimo - usuariosPorPagina;
//   const usuariosActuales = filteredUsuarios.slice(indexPrimero, indexUltimo);
//   const totalPaginas = Math.ceil(filteredUsuarios.length / usuariosPorPagina);

//   const obtenerAvatar = (foto) => {
//     if (foto) return foto.startsWith("http") ? foto : `http://localhost:5001/uploads/perfiles/${foto}`;
//     return "http://localhost:5001/uploads/perfiles/default-avatar.png";
//   };

//   return (
//     <div className="user-panel">
//       <h2>👥 Gestión de Usuarios</h2>
//       {tenantNombre && <p><strong>Institución:</strong> {tenantNombre}</p>}
//       {msg && <p className="success">{msg}</p>}
//       {error && <p className="error">{error}</p>}

//       <div className="form-group">
//         <input type="text" name="documento" placeholder="Documento" value={formData.documento} onChange={handleChange} />
//         <input type="password" name="password" placeholder="Contraseña" value={formData.password} onChange={handleChange} required={!editandoId} />

//         <select name="role" value={formData.role} onChange={handleChange}>
//           <option value="estudiante">Estudiante</option>
//           <option value="profesor">Profesor</option>
//           <option value="coordinador">coordinador</option>
//           <option value="rector">Rector</option>
//           <option value="secretaria">Secretaria</option>
//           <option value="padre">Padre</option>
//         </select>

//         <input type="text" name="nombre" placeholder="Nombre" value={formData.nombre} onChange={handleChange} />
//         <input type="text" name="apellido" placeholder="Apellido" value={formData.apellido} onChange={handleChange} />
//         <input type="email" name="email" placeholder="Correo" value={formData.email} onChange={handleChange} />
//         <input type="text" name="telefono" placeholder="Teléfono" value={formData.telefono} onChange={handleChange} />
//         <input type="date" name="fecha_nacimiento" value={formData.fecha_nacimiento} onChange={handleChange} />
//         <input type="text" name="direccion" placeholder="Dirección" value={formData.direccion} onChange={handleChange} />

//         {formData.role !== "rector" && (
//           <select name="asignar_a" value={formData.asignar_a} onChange={handleChange}>
//             <option value="tenant">{tenantNombre ? `Asignar a ${tenantNombre}` : "Asignar a la Institución"}</option>
//             <option value="sede">Asignar a una Sede</option>
//           </select>
//         )}

//         {formData.asignar_a === "sede" && (
//           <select name="sede_id" value={formData.sede_id} onChange={handleChange}>
//             <option value="">Selecciona la Sede</option>
//             {sedes.map(s => (<option key={s.id} value={s.id}>{s.nombre}</option>))}
//           </select>
//         )}

//         <button onClick={guardarUsuario}>{editandoId ? "Actualizar" : "Guardar"}</button>
//         {editandoId && <button onClick={limpiarFormulario}>Cancelar</button>}
//       </div>

//       <div className="search-bar">
//         <input type="text" placeholder="Buscar" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
//       </div>

//       <table className="user-table">
//         <thead>
//           <tr>
//             <th>Foto</th>
//             <th>Usuario</th>
//             <th>Rol</th>
//             <th>Nombre</th>
//             <th>Documento</th>
//             <th>Correo</th>
//             <th>Teléfono</th>
//             <th>Sede</th>
//             <th>Acciones</th>
//           </tr>
//         </thead>
//         <tbody>
//           {usuariosActuales.map(u => (
//             <tr key={u.id} className={u.activo ? "" : "desactivado"}>
//               <td><img src={obtenerAvatar(u.foto)} alt="avatar" className="avatar" /></td>
//               <td>{u.username}</td>
//               <td>{u.role}</td>
//               <td>{u.nombre} {u.apellido}</td>
//               <td>{u.documento}</td>
//               <td>{u.email}</td>
//               <td>{u.telefono}</td>
//               <td>{u.sede_nombre || "Institución principal"}</td>
//               <td>
//                 <button className="edit" disabled={!u.activo} onClick={() => {
//                   setEditandoId(u.id);
//                   setFormData({ ...u, password: "", asignar_a: u.sede_id ? "sede" : "tenant", sede_id: u.sede_id || "" });
//                 }}>✏️</button>
//                 <button className="delete" disabled={!u.activo} onClick={() => eliminarUsuario(u.id)}>🗑️</button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <div className="pagination">
//         {Array.from({ length: totalPaginas }, (_, i) => (
//           <button key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)}>
//             {i + 1}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// }


//

import React, { useState, useEffect, useMemo, useCallback } from "react";
// 1. Usamos la instancia unificada y la URL base desde config
import axios from "../../api/axiosAuth";
import { API } from "../../components/config"; 
import { useAuth } from "../../context/AuthContext";
import "../../style/CreateUser.css";

export default function CreateUser() {
  const { token, logout, user } = useAuth();
  const tenant_id = user?.tenant_id;

  // Estados de formulario
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    role: "estudiante",
    nombre: "",
    apellido: "",
    documento: "",
    email: "",
    telefono: "",
    fecha_nacimiento: "",
    direccion: "",
    asignar_a: "tenant",
    sede_id: ""
  });

  // Estados de datos y UI
  const [usuarios, setUsuarios] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [tenantNombre, setTenantNombre] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const usuariosPorPagina = 8;

  /* =========================================
      🔄 CARGA DE DATOS (AXIOS CENTRALIZADO)
  ========================================= */
  
  const obtenerUsuarios = useCallback(async () => {
    try {
      // Usamos rutas relativas; axiosAuth ya sabe que debe ir a /api/users/usuarios
      const res = await axios.get("/users/usuarios");
      setUsuarios(res.data || []);
    } catch (err) {
      console.error("❌ Error usuarios:", err);
      if ([401, 403].includes(err.response?.status)) logout();
      else setError("No se pudieron cargar los usuarios");
    }
  }, [logout]);

  const obtenerSedes = useCallback(async () => {
    try {
      const res = await axios.get("/users/sedes", { params: { tenant_id } });
      setSedes(res.data || []);
    } catch (err) {
      setSedes([]);
    }
  }, [tenant_id]);

  const obtenerNombreTenant = useCallback(async () => {
    try {
      const res = await axios.get(`/users/tenant/${tenant_id}`);
      setTenantNombre(res.data?.nombre || "");
    } catch (err) {
      setTenantNombre("");
    }
  }, [tenant_id]);

  useEffect(() => {
    if (token && tenant_id) {
      obtenerUsuarios();
      obtenerSedes();
      obtenerNombreTenant();
    }
  }, [token, tenant_id, obtenerUsuarios, obtenerSedes, obtenerNombreTenant]);

  /* =========================================
      💾 LÓGICA DE GUARDADO Y EDICIÓN
  ========================================= */

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ 
      ...prev, 
      [name]: value, 
      ...(name === "documento" && { username: value }) 
    }));
    setError(""); 
    setMsg("");
  };

  const guardarUsuario = async () => {
    if (!formData.documento || !formData.nombre || !formData.apellido) {
      return setError("⚠️ Documento, nombre y apellido son obligatorios");
    }
    if (!editandoId && (!formData.password || formData.password.length < 6)) {
      return setError("⚠️ La contraseña debe tener al menos 6 caracteres");
    }

    const sede_id = formData.asignar_a === "sede" ? Number(formData.sede_id) : null;
    const dataToSend = { ...formData, tenant_id, sede_id };

    try {
      if (editandoId) {
        const rectorUsername = prompt("Confirmación: Usuario del administrador/rector:");
        const rectorPassword = prompt("Confirmación: Contraseña del administrador/rector:");
        if (!rectorUsername || !rectorPassword) return setError("Credenciales requeridas");

        dataToSend.rectorUsername = rectorUsername;
        dataToSend.rectorPassword = rectorPassword;
        if (!dataToSend.password) delete dataToSend.password;

        await axios.put(`/users/usuarios/${editandoId}`, dataToSend);
        setMsg("✅ Usuario actualizado correctamente");
      } else {
        await axios.post("/users/usuarios", dataToSend);
        setMsg("✅ Usuario creado exitosamente");
      }

      limpiarFormulario();
      obtenerUsuarios();
    } catch (err) {
      setError(err.response?.data?.message || "Error al procesar la solicitud");
    }
  };

  const eliminarUsuario = async (id) => {
    if (!window.confirm("⚠️ ¿Seguro quieres eliminar este usuario?")) return;

    try {
      const rectorUsername = prompt("Confirmación: Usuario del administrador/rector:");
      const rectorPassword = prompt("Confirmación: Contraseña del administrador/rector:");
      if (!rectorUsername || !rectorPassword) return;

      await axios.delete(`/users/usuarios/${id}`, {
        data: { rectorUsername, rectorPassword }
      });
      setMsg("✅ Usuario eliminado");
      obtenerUsuarios();
    } catch (err) {
      setError(err.response?.data?.message || "Error al eliminar");
    }
  };

  const limpiarFormulario = () => {
    setFormData({
      username: "", password: "", role: "estudiante", nombre: "", apellido: "",
      documento: "", email: "", telefono: "", fecha_nacimiento: "", direccion: "",
      asignar_a: "tenant", sede_id: ""
    });
    setEditandoId(null);
    setError(""); 
    setMsg("");
  };

  /* =========================================
      🔍 FILTROS Y PAGINACIÓN
  ========================================= */

  const filteredUsuarios = useMemo(() => {
    return usuarios.filter(u =>
      `${u.nombre} ${u.apellido} ${u.documento} ${u.email}`
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  }, [usuarios, searchTerm]);

  const indexUltimo = currentPage * usuariosPorPagina;
  const indexPrimero = indexUltimo - usuariosPorPagina;
  const usuariosActuales = filteredUsuarios.slice(indexPrimero, indexUltimo);
  const totalPaginas = Math.ceil(filteredUsuarios.length / usuariosPorPagina);

  const obtenerAvatar = (foto) => {
    if (foto) return foto.startsWith("http") ? foto : `${API}/uploads/perfiles/${foto}`;
    return `${API}/uploads/perfiles/default-avatar.png`;
  };

  return (
    <div className="user-panel">
      <header className="user-header">
        <h2>👥 Gestión de Usuarios</h2>
        <p>Institución: <strong>{tenantNombre || "Cargando..."}</strong></p>
      </header>

      {msg && <div className="alert-msg success">{msg}</div>}
      {error && <div className="alert-msg error">{error}</div>}

      <div className="form-container-grid">
        <input type="text" name="documento" placeholder="N° Documento (Username)" value={formData.documento} onChange={handleChange} />
        <input type="password" name="password" placeholder={editandoId ? "Nueva contraseña (opcional)" : "Contraseña"} value={formData.password} onChange={handleChange} />

        <select name="role" value={formData.role} onChange={handleChange}>
          <option value="estudiante">Estudiante</option>
          <option value="profesor">Profesor</option>
          <option value="coordinador">Coordinador</option>
          <option value="rector">Rector</option>
          <option value="secretaria">Secretaria</option>
          <option value="padre">Padre</option>
        </select>

        <input type="text" name="nombre" placeholder="Nombres" value={formData.nombre} onChange={handleChange} />
        <input type="text" name="apellido" placeholder="Apellidos" value={formData.apellido} onChange={handleChange} />
        <input type="email" name="email" placeholder="Correo Electrónico" value={formData.email} onChange={handleChange} />
        <input type="text" name="telefono" placeholder="Teléfono" value={formData.telefono} onChange={handleChange} />
        <input type="date" name="fecha_nacimiento" value={formData.fecha_nacimiento} onChange={handleChange} title="Fecha de Nacimiento" />
        <input type="text" name="direccion" placeholder="Dirección de residencia" value={formData.direccion} onChange={handleChange} />

        {formData.role !== "rector" && (
          <select name="asignar_a" value={formData.asignar_a} onChange={handleChange}>
            <option value="tenant">Asignar a Institución Global</option>
            <option value="sede">Asignar a Sede Específica</option>
          </select>
        )}

        {formData.asignar_a === "sede" && (
          <select name="sede_id" value={formData.sede_id} onChange={handleChange} required>
            <option value="">-- Seleccione la Sede --</option>
            {sedes.map(s => (<option key={s.id} value={s.id}>{s.nombre}</option>))}
          </select>
        )}

        <div className="form-actions">
          <button className="btn-save" onClick={guardarUsuario}>{editandoId ? "Actualizar Usuario" : "Registrar Usuario"}</button>
          {editandoId && <button className="btn-cancel" onClick={limpiarFormulario}>Cancelar</button>}
        </div>
      </div>

      <div className="list-container">
        <div className="list-header">
          <h3>Listado de Usuarios</h3>
          <input type="text" className="search-input" placeholder="Buscar por nombre, documento o correo..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
        </div>

        <div className="table-responsive">
          <table className="user-table">
            <thead>
              <tr>
                <th>Foto</th>
                <th>Usuario</th>
                <th>Rol</th>
                <th>Nombre Completo</th>
                <th>Documento</th>
                <th>Sede / Ubicación</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuariosActuales.map(u => (
                <tr key={u.id} className={u.activo ? "" : "row-inactive"}>
                  <td><img src={obtenerAvatar(u.foto)} alt="avatar" className="table-avatar" /></td>
                  <td><strong>{u.username}</strong></td>
                  <td><span className={`role-badge ${u.role}`}>{u.role}</span></td>
                  <td>{u.nombre} {u.apellido}</td>
                  <td>{u.documento}</td>
                  <td>{u.sede_nombre || "Sede Principal"}</td>
                  <td className="table-actions">
                    <button title="Editar" onClick={() => {
                      setEditandoId(u.id);
                      setFormData({ 
                        ...u, 
                        password: "", 
                        asignar_a: u.sede_id ? "sede" : "tenant", 
                        sede_id: u.sede_id || "" 
                      });
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}>✏️</button>
                    <button title="Eliminar" className="btn-del" onClick={() => eliminarUsuario(u.id)}>🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          {Array.from({ length: totalPaginas }, (_, i) => (
            <button key={i} className={currentPage === i + 1 ? "active" : ""} onClick={() => setCurrentPage(i + 1)}>
              {i + 1}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}